@if (isShownAlert) {
  <div
    [class]="inlineClasses()"
    [class]="styles[style()]"
    class="alert-sticky flex justify-between items-center py-md px-4xl shadow-xs">
    <div class="flex">
      @if (icon()) {
        <div class="icon me-sm">
          <img [src]="icon()" alt="icon" width="20" height="20" />
        </div>
      }
      <div class="info font-medium">
        {{ message() }}
      </div>
    </div>

    <div class="flex">
      <div class="actions">
        <ng-content />
      </div>
      <button class="ms-sm" type="button" (click)="closeAlert()">
        @if (style() === 'primary1') {
          <img [src]="'assets/icons/close/white.svg'" alt="close icon" />
        } @else if (style() === 'primary2') {
          <img [src]="'assets/icons/close/primary.svg'" alt="close icon" />
        } @else {
          <img [src]="'assets/icons/close/black.svg'" alt="close icon" />
        }
      </button>
    </div>
  </div>
}
